import template from './project-watermark.pug';

export const ProjectWatermarkComponent = {
  template,
  bindings:{
    project: '<'
  },
  controller: class ProjectWatermarkComponent {
    constructor($async, $log, Project, Upload) {
      'ngInject';
      this.$log = $log;
      this.Project = Project;
      this.Upload = Upload;
      this.selectConfig = {
        valueField: 'value',
        labelField: 'title',
        maxItems: 1,
        plugins: [],
        translate: true,
      };
      this.gravityPositions = [
        'NorthEast', 'North', 'NorthWest',
        'East', 'Center', 'West',
        'SouthEast', 'South', 'SouthWest'];

      this.uploadWatermark = $async(this.uploadWatermark.bind(this));
      this.updateGravity = $async(this.updateGravity.bind(this));
      this.removeWatermark = $async(this.removeWatermark.bind(this));
    }

    $onInit() {}

    async uploadWatermark() {
      try {
        this.loader = true;
        const response = await this.Upload.upload({
          url: window.apiHost + '/projects/' + this.project.id + '/watermark',
          data: { watermark: this.watermark }
        }).finally(() => {
          this.loader = false;
        });
        this.project.watermark_url = response.data;
      } catch (e) {
        this.$log.error(e);
      }
    }


    async updateGravity(gravity) {
      this.project.watermark_gravity = gravity;
      try {
        this.loader = true;
        this.project.watermark_url = await this.Project.watermarkGravity(this.project);
      } catch (e) {
        this.$log.error(e);
      } finally {
        this.loader = false;
      }
    }

    onGravityChange() {
      this.updateGravity();
    }

    async removeWatermark() {
      try {
        this.loader = true;
        await this.Project.removeWatermark(this.project.id);
      } catch (e) {
        this.$log.error(e);
      } finally {
        this.loader = false;
      }
    }


  }
};
